import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { TSTreeNode } from 'tsui';

import { SettingsService } from './settings.service';
import { TsPageSidenavConfig } from 'tsui/lib/ts-page/ts-page.component';

@Component({
  selector: 'settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsComponent {
  readonly options: TSTreeNode[] = inject(SettingsService).settingsOptions;
  readonly sidenavConfig: TsPageSidenavConfig = {
    title: 'Settings',
  };
}
